
<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Abonos</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="form-inline">
            <input
              class="form-control form-control-sm rounded bright"
              placeholder="Search"
              v-model="searchtext"
              type="text"
              style="width: 500px"
              v-on:keyup.enter="filterData"
            />
            <div class="input-group-append">
              <button
                class="btn btn-link btn-sm"
                type="button"
                v-on:click="filterData"
                style="width: 60px"
              >
                <i class="fa fa-search"></i>
                Buscar
              </button>
            </div>
          </div>
          <br />
          <div class="row">
            <div>
              <div class="form-inline justify-content-sm-end">
                <input
                  class="
                    form-control
                    text-center
                    form-control-sm
                    rounded
                    bright
                  "
                  placeholder="Serie"
                  v-model="search.abono_serie"
                  type="text"
                  style="width: 80px; text-transform: uppercase"
                  v-on:keyup.enter="filterData"
                />
                &nbsp;&nbsp;
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Nit cliente"
                  v-model="search.cliente"
                  type="text"
                  v-on:keyup.enter="filterData"
                  style="width: 100px; text-transform: uppercase"
                />
                &nbsp;&nbsp;
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="# Abono"
                  v-model="search.numero"
                  type="text"
                  style="width: 80px; text-transform: uppercase"
                  v-on:keyup.enter="filterData"
                />
                &nbsp;&nbsp;
                <input
                  type="date"
                  v-model="search.fecha"
                  style="width: 140px"
                  class="form-control form-control-sm rounded bright"
                />
                &nbsp;&nbsp;
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filtro_tienda"
                  @change="filterData"
                  style="width: 150px"
                >
                  <option value="">Tiendas</option>
                  <option
                    v-for="data in tiendas"
                    :value="data.codigo"
                    v-bind:key="data.id"
                  >
                    {{ data.nombre }}
                  </option>
                </select>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filtro_tipo_abono"
                  @change="filterData"
                  style="width: 158px"
                >
                  <option value>Tipo Abono</option>
                  <option value="RC">Recibo</option>
                  <option value="ENCR">Nota de Credito</option>
                </select>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filtro_estado"
                  @change="filterData"
                  style="width: 108px"
                >
                  <option value>Estatus</option>
                  <option value="9">Anulado</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                  <option value="E">IMPRESA</option>
                </select>
                <div class="input-group-append">
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="filterData"
                    style="width: 60px"
                  >
                    <i class="fa fa-search"></i>
                    Buscar
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                    style="width: 30px"
                  >
                    <i class="fa fa-times"></i>
                    Limpiar Datos
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AbonoTableComponent :data="data" />
        <PaginationComponent
          :currentPage="currentPage"
          :data="data"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
  </div>
</template> 
<script>
import AbonoTableComponent from "@/components/cxc/abonos/AbonoTableComponent";
import NuevoAbonoModalComponent from "@/components/cxc/abonos/NuevoAbonoModalComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";
export default {
  components: {
    AbonoTableComponent,
    NuevoAbonoModalComponent,
    PaginationComponent,
  },
  data() {
    return {
      search: [],
      mostrarRefresh: false,
      currentPage: 1,
      filtro_estado: "",
      data: "",
      page: "",
      tiendas: "",
      filtro_tienda: "",
      searchtext: "",
      filtro_tipo_abono: "",
    };
  },
  mounted() {
    let self = this;
    self.refreshData();
    self.refreshTienda();
  },
  methods: {
    refreshTienda() {
      let self = this;
      DynamicService.fetch("cat", "tiendas", {
        quitar_paginacion: true,
      }).then((response) => {
        self.tiendas = response.data;
      });
    },
    convertFormatDate(search) {
      search.fecha_creacion = moment(search.fecha).format("DD/MM/YYYY");
    },
    onPageChange(page) {
      let self = this;
      if (this.search.fecha) {
        this.convertFormatDate(this.search);
      }
      this.currentPage = page;
      DynamicService.fetch("cxc", "abonos", {
        page: page,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
        abono_serie__cxc_tipo_abono: this.filtro_tipo_abono,
        abono_serie: this.search.abono_serie,
        cliente: this.search.cliente,
        numero: this.search.numero,
        tienda: this.filtro_tienda,
        fecha: this.search.fecha_creacion,
      }).then((response) => {
        self.data = response.data;
      });
    },
    refreshData() {
      let self = this;
      DynamicService.fetch("cxc", "abonos").then((response) => {
        self.data = response.data;
      });
    },
    refreshSerie() {
      let self = this;
      DynamicService.fetch("cxc", "abonos").then((response) => {
        self.data = response.data;
      });
    },
    filterData() {
      this.$data.currentPage = 1;
      if (this.search.fecha) {
        this.convertFormatDate(this.search);
      }
      DynamicService.fetch("cxc", "abonos", {
        page: this.$data.currentPage,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
        tienda: this.filtro_tienda,
        abono_serie__cxc_tipo_abono: this.filtro_tipo_abono,
        abono_serie: this.search.abono_serie,
        cliente: this.search.cliente,
        numero: this.search.numero,
        fecha: this.search.fecha_creacion,
      }).then((response) => {
        this.data = response.data;
      });
    },
    clearFilterData() {
      this.filtro_tienda = "";
      this.filtro_estado = "";
      this.searchtext = "";
      this.search = {
        abono_serie: "",
        cliente: "",
        numero: "",
        fecha: "",
      };
      this.$data.currentPage = 1;
      this.filterData();
    },
  },
};
</script>
